"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _react = _interopRequireWildcard(require("react"));

var _SortOptions = _interopRequireDefault(require("../constants/SortOptions"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _langUtils = require("../utils/langUtils");

var getSortOptions = function getSortOptions() {
  return [_SortOptions.default.MOST_DOWNLOADED, _SortOptions.default.RECENTLY_ADDED, _SortOptions.default.PRICE_LOW_TO_HIGH, _SortOptions.default.PRICE_HIGH_TO_LOW];
};

var _default = _react.default.createClass({
  displayName: "SortOptionsDropdown",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    buttonClassName: _react.PropTypes.string,
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    sortingFilter: _react.PropTypes.string.isRequired
  },
  getGoodFilterChangeHandlerForSorting: function getGoodFilterChangeHandlerForSorting(sortingFilter) {
    var params = {};
    params[_GoodFiltersAndPage.default.SORT_BY] = sortingFilter;
    return this.props.onGoodFilterChange(params);
  },
  renderDropdownItems: function renderDropdownItems(sortingFilter) {
    var _this = this;

    return getSortOptions().map(function (sortingOption) {
      if (sortingOption !== sortingFilter) {
        return _react.default.createElement(_UIButton.default, {
          className: "integrate-" + sortingOption,
          key: sortingOption,
          onClick: _this.partial(_this.getGoodFilterChangeHandlerForSorting, sortingOption),
          use: "link"
        }, (0, _langUtils.getFriendlySortingOptionName)(sortingOption));
      }

      return null;
    });
  },
  render: function render() {
    var _this$props = this.props,
        buttonClassName = _this$props.buttonClassName,
        sortingFilter = _this$props.sortingFilter;
    return _react.default.createElement(_UIDropdown.default, {
      buttonClassName: "integrate-sort-dropdown-button p-all-0 " + buttonClassName,
      buttonText: (0, _langUtils.getFriendlySortingOptionName)(sortingFilter),
      buttonUse: "transparent"
    }, _react.default.createElement(_UIList.default, null, this.renderDropdownItems(sortingFilter)));
  }
});

exports.default = _default;
module.exports = exports.default;